// =====================================================
// BRIDGE — Connects core + pro bundles at runtime
// Uses a shared global object so both IIFE bundles access the same state,
// even though each bundle gets its own inlined copy of this module.
//
// Now only used for PDF parsing (pro-only).
// Move detection and DOCX generation are in the core bundle.
// =====================================================

import type { PdfParserFn } from './types';

interface BridgeState {
  pdfParser: PdfParserFn | null;
  proActive: boolean;
}

// Both bundles (core IIFE + pro IIFE) get their own copy of this module,
// but they share state via a global object on globalThis.
function getBridgeState(): BridgeState {
  const g = globalThis as any;
  if (!g.__fredlineBridge) {
    g.__fredlineBridge = {
      pdfParser: null,
      proActive: false,
    };
  }
  return g.__fredlineBridge;
}

export function registerPdfParser(parser: PdfParserFn): void {
  getBridgeState().pdfParser = parser;
}

export function getPdfParser(): PdfParserFn | null {
  return getBridgeState().pdfParser;
}

/** Returns true when the pro bundle has loaded and registered. */
export function isProActive(): boolean {
  return getBridgeState().proActive;
}

// Called by pro bundle on load
export function activatePro(pro: {
  parsePdfFile: PdfParserFn;
}): void {
  registerPdfParser(pro.parsePdfFile);
  getBridgeState().proActive = true;
}
